import { Logger } from 'bernie-logger';

import { EtpViewModel, HotelRoomsAndRatesViewModel, ParagraphViewModel } from 'models';

import { adaptRooms } from './property-units-adapter';

export const adaptPropertyInfoOffers = (response, useBexApiPdpMigrationFeatures, logger: Logger): HotelRoomsAndRatesViewModel => {
  const propertyInfoOffers = response?.data?.propertyInfo?.pwaOnlyBffResponse?.offers;
  const roomsAndRates = propertyInfoOffers ? JSON.parse(propertyInfoOffers) : response;
  if (propertyInfoOffers && useBexApiPdpMigrationFeatures) {
    if (hasPaymentPolicies(response)) {
      roomsAndRates.etp = adaptEtp(response);
    }

    roomsAndRates.rooms = adaptRooms(response, roomsAndRates.rooms);
  }

  return roomsAndRates;
};

function hasPaymentPolicies(response: any) {
  return response?.data?.propertyInfo?.offers?.paymentPolicy;
}

export function adaptEtp(response: any): EtpViewModel {
  const paymentPolicies = response.data.propertyInfo.offers.paymentPolicy;
  const etp: EtpViewModel = {
    PAY_NOW: adaptLines('PAY_NOW', paymentPolicies)
  };

  const payLaterLines = adaptLines('PAY_LATER', paymentPolicies).filter(item => item.lines.length > 0);
  if (payLaterLines && payLaterLines.length > 0) {
    etp['PAY_LATER'] = payLaterLines;
  }

  const payLaterWithDepositLines = adaptLines('PAY_LATER_WITH_DEPOSIT', paymentPolicies).filter(item => item.lines.length > 0);
  if (payLaterWithDepositLines && payLaterWithDepositLines.length > 0) {
    etp['PAY_LATER_WITH_DEPOSIT'] = payLaterWithDepositLines;
  }

  return etp;
}

function adaptLines(paymentType: string, paymentPolicies: any): ParagraphViewModel[] {
  return paymentPolicies.filter(item => item.paymentType === paymentType).map(item => adaptParagraphViewModel(item.text));
}

export function adaptParagraphViewModel(text: string[]): ParagraphViewModel {
  return {
    lines: text
  } as ParagraphViewModel;
}
